import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Modal, Form, Col, Row } from "react-bootstrap";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FormGroup from "@material-ui/core/FormGroup";
import Button from "@material-ui/core/Button";
import { useDispatch, useSelector } from "react-redux";
import { editEvent, eventAccesActions, sendEmail } from "../../actions/auth";
import LoaderGif from "../modules/loader";
import { statusErrorSuccess } from "../../App";
import {generate} from "generate-password";

const REACT_APP_MAIL_FROM = process.env.REACT_APP_MAIL_FROM;
const REACT_APP_MAIL_CREATE_USER_SUBJECT =
  process.env.REACT_APP_MAIL_CREATE_USER_SUBJECT;
const REACT_APP_MAIL_HEADER = process.env.REACT_APP_MAIL_HEADER;
const REACT_APP_MAIL_FOOTER = process.env.REACT_APP_MAIL_FOOTER;
const REACT_APP_VLL_DEMO_URL = process.env.REACT_APP_VLL_DEMO_URL;
const ENV_ADMIN_ID = process.env.REACT_APP_ADMIN_ID;
const ENV_AUTHENTICATED_ID = process.env.REACT_APP_AUTHENTICATED_ID;
const ENV_DEFAULT_LANG = process.env.REACT_APP_DEFAULT_LANG;
const ENV_EVENT_URL = process.env.REACT_APP_EVENT_URL;

const AddArea = (props) => {
  const dispatch = useDispatch();
  const { createEventAccessData } = useSelector((state) => state.auth);
  const [loader, setLoader] = useState(false);
  const [userFormData, setUserFormData] = useState("");
  const { register, handleSubmit, setValue, errors } = useForm({
    defaultValues: "",
  });
  const [languageVal, setLanguageVal] = useState(
    props.eventAccessOrgValue.base_configuration[0].language
      ? props.eventAccessOrgValue.base_configuration[0].language
      : ENV_DEFAULT_LANG
  );

  const onSubmitAccessAction = async (data) => {
    if (data.access_email_id) {
      setLoader(true);
      var generateNewPwd = generate({
        length: 8,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true,
        exclude: '"',
      });
      let finalData = {
        firstName: data.access_fname,
        // "lastName": data.access_lname,
        email: data.access_email_id,
        password: generateNewPwd,
      };
      setUserFormData(finalData);

      dispatch(eventAccesActions(finalData))
        .then(() => {
          setLoader(false);
          props.onHide();
        })
        .catch((error) => {
          setLoader(false);
        });
    }
  };

  useEffect(() => {
    if (createEventAccessData) {
      let finalData = props.eventAccessOrgValue;
      finalData.event_users.push({
        user_name: userFormData.firstName,
        user_email: userFormData.email,
      });

      dispatch(editEvent(finalData, props.eventType, finalData.id))
        .then(() => {
          setLoader(false);
          statusErrorSuccess("eventUpdatedSuccess", "success");
        })
        .catch(() => {
          setLoader(false);
          statusErrorSuccess("addEventAccessFailed", "danger");
        });

      let sendEmailData = {};
      sendEmailData.from = REACT_APP_MAIL_FROM;
      sendEmailData.to = [];
      sendEmailData.to[0] = userFormData.email;
      sendEmailData.subject = REACT_APP_MAIL_CREATE_USER_SUBJECT;

      if (createEventAccessData.message) {
        sendEmailData.html =
          REACT_APP_MAIL_HEADER +
          "<tr style='background:#fff; text-align: left;'>\
            <td style='padding: 16px 30px 30px; text-align: left; font-size: 16px; line-height:1.5;'>\
               <h4 style='color: #7E7E7E; font-size: 19px; line-height: 1.5; font-weight: 700; margin:16px 0; padding: 0; text-transform:capitalize;'>Dear " +
          userFormData.firstName +
          ",</h4>\
               <p style='color: #696969; font-size: 16px; line-height: 1.5; margin: 16px 0 20px; padding: 0;'>Thank you for registering for the <span style='color: #696969; font-weight:bold; font-size:16px; line-height:1.5; '>" +
          finalData.event_name +
          "</span> session/event. Here is the <a class='color:#097DBF;' href='" +
          ENV_EVENT_URL +
          props.eventAccessOrgValue.access_id +
          "&lang=" +
          languageVal +
          "'>link </a> to the event.</p>\
              <p style='color: #696969; font-size: 16px; line-height: 1.5; margin: 16px 0 20px; padding: 0;'>Kindly copy and paste the above URL in your Google Chrome or Microsoft Edge browser. The experience works best on a good internet speed of at least 10 MBPS or more.</p>\
               <p style='color: #696969; font-size: 16px; line-height: 1.5; margin: 16px 0 20px; padding: 0;'>To access the Virtual Living Labs, use your username and password.</span></p>\
               <p style='color: #696969; font-size: 16px; line-height: 1.5; margin: 16px 0 20px; padding: 0;'>When you log in for the first time, you will be prompted to change the auto-generated password to a password of your choice.</p>\
               <p style='color: #696969; font-size: 16px; line-height: 1.5; margin: 16px 0 20px; padding: 0;'>We look forward to engaging with you.</p>\
               " +
          REACT_APP_MAIL_FOOTER;
        dispatch(sendEmail(sendEmailData))
          .then(() => {
            setUserFormData("");
            setLoader(false);
            statusErrorSuccess("addEventAccessFailed", "success");
          })
          .catch((error) => {
            setUserFormData("");
            setLoader(false);
          });
      } else {
        sendEmailData.html =
          REACT_APP_MAIL_HEADER +
          "<tr style='background:#fff; text-align: left;'>\
            <td style='padding: 16px 30px 30px; text-align: left; font-size: 16px; line-height:1.5;'>\
               <h4 style='color: #7E7E7E; font-size: 19px; line-height: 1.5; font-weight: 700; margin:16px 0; padding: 0; text-transform:capitalize;'>Dear " +
          userFormData.firstName +
          ",</h4>\
               <p style='color: #696969; font-size: 16px; line-height: 1.5; margin: 16px 0 20px; padding: 0;'>Thank you for registering for the <span style='color: #696969; font-weight:bold; font-size:16px; line-height:1.5; '>" +
          finalData.event_name +
          "</span> session/event. Here is the <a class='color:#097DBF;' href='" +
          ENV_EVENT_URL +
          props.eventAccessOrgValue.access_id +
          "&lang=" +
          languageVal +
          "'>link </a> to the event.</p>\
               <p style='color: #696969; font-size: 16px; line-height: 1.5; margin: 16px 0 20px; padding: 0;'>Kindly copy and paste the above URL in your Google Chrome or Microsoft Edge browser. The experience works best on a good internet speed of at least 10 MBPS or more.</p>\
               <p style='color: #696969; font-size: 16px; line-height: 1.5; margin: 16px 0 20px; padding: 0;'>To access the Virtual Living Labs, use your email ID (in which you have received this communication) as the username, and your auto-generated password is <span style='color: #696969; font-weight:bold; font-size:16px; line-height:1.5;'>" +
          userFormData.password +
          "</span></p>\
               <p style='color: #696969; font-size: 16px; line-height: 1.5; margin: 16px 0 20px; padding: 0;'>When you log in for the first time, you will be prompted to change the auto-generated password to a password of your choice.</p>\
               <p style='color: #696969; font-size: 16px; line-height: 1.5; margin: 16px 0 20px; padding: 0;'>We look forward to engaging with you.</p>\
               " +
          REACT_APP_MAIL_FOOTER;
        dispatch(sendEmail(sendEmailData))
          .then(() => {
            setUserFormData("");
            setLoader(false);
            statusErrorSuccess("addEventAccessSuccess", "success");
          })
          .catch((error) => {
            setUserFormData("");
            setLoader(false);
          });
      }
    }
  }, [createEventAccessData]);

  return (
    <React.Fragment>
      <Modal
        show={props.show}
        onHide={props.onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="ad-area-modal area_global_popup add-showcase-modal"
      >
        <Modal.Header>
          <h4 className="popup_title">
            {props.areaaction === "EDIT" ? "Edit Member" : "Add Memeber"}
          </h4>
          <p className="popup_close_icon" onClick={props.onHide}>
            <img className="img-fluid" src="/images/close.svg" alt="" />
          </p>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmitAccessAction)}>
            <Row>
              <Col xl={6} lg={6}>
                <FormGroup className="material-group">
                  <FormControl variant="outlined">
                    <InputLabel
                      htmlFor="EventAccessName"
                      className="label-caption"
                    >
                      Name
                    </InputLabel>
                    <OutlinedInput
                      id="EventAccessFName"
                      type="text"
                      name="access_fname"
                      className="material"
                      inputRef={register({
                        required: false,
                      })}
                    />
                  </FormControl>
                </FormGroup>
              </Col>
              {/* <Col xl={6} lg={6}>
            <FormGroup className="material-group">
              <FormControl variant="outlined">
                <InputLabel htmlFor="EventAccessName " className="label-caption">Last Name</InputLabel>
                <OutlinedInput id="EventAccessLName" type="text" name="access_lname" className="material"
                inputRef={register({
                  required: false,
                })} />
              </FormControl>
            </FormGroup>
            </Col> */}
              <Col xl={6} lg={6}>
                <FormGroup className="material-group">
                  <FormControl variant="outlined">
                    <InputLabel
                      htmlFor="EventAccessEmail "
                      className="label-caption"
                    >
                      Email address
                    </InputLabel>
                    <OutlinedInput
                      id="EventAccessEmail"
                      type="text"
                      name="access_email_id"
                      className="material"
                      inputRef={register({
                        required: true,
                      })}
                    />
                    {errors.access_email_id?.type === "required" && (
                      <p className="error_msg">Please enter email address.</p>
                    )}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col lg={12} className="mr-auto text-right">
                <FormGroup className="material-group d-inline-block">
                  {props.eventAccessAction === "EDIT" ? (
                    <Button type="submit" variant="contained" color="primary">
                      Update
                    </Button>
                  ) : (
                    <Button type="submit" variant="contained" color="primary">
                      Add
                    </Button>
                  )}
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      {loader === true && <LoaderGif />}
    </React.Fragment>
  );
};
export default AddArea;
